var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('elsa-tree',{attrs:{"accordion":"","icon-class":"tree-icon","data":_vm.treeData,"selected-items":_vm.selectedItems},on:{"node-click":_vm.handleNodeClick,"add-remove":_vm.handleAddRemove},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var node = ref.node;
return [_c('span',{class:node.data.options.titleClassArray},[_vm._v(" "+_vm._s(_vm.getTitleByLevel(node))+" ")])]}},{key:"tags",fn:function(ref){
var node = ref.node;
return [_c('span',{staticClass:"tag"},[_vm._v(_vm._s(node.data.difficulty_level))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }